<template>
<div class="chapter">
<div class="inner_page">
<h2 class="prect"><a id="pvii"></a>Contents</h2>
<p class="contents" id="ch0">     <i><a href="#/Title_Page.htm">Title Page</a></i></p>
<p class="contents" id="ch0a">     <i><a href="#/Dedication.htm">Dedication</a></i></p>
<p class="contents" id="ch0c">     <i><a href="#/List_of_Maps.htm">List of Maps</a></i></p>
<p class="contents" id="ch0d">     <i><a href="#/Authors_Note.htm">Author’s note</a></i></p>
<p class="contents" id="ch0e">     <i><a href="#/Preface.htm">Preface</a></i></p>
<p class="linespace"></p>
<p class="contents" id="ch0f"><a href="#/PART_I_EUROPE.htm"><span class="part">PART I EUROPE</span></a></p>
<p class="contents" id="ch1">  <a href="#/1_Becoming_a_POW.htm">1. Becoming a POW</a></p>
<p class="contents" id="ch2">  <a href="#/2_Settling_In_and_Getting_By.htm">2. Settling In and Getting By</a></p>
<p class="contents" id="ch3">  <a href="#/3_Uses_for_a_Red_Cross_Parcel_Number_1__String.htm">3. Uses for a Red Cross Parcel Number 1 – String</a></p>
<p class="contents" id="ch4">  <a href="#/4_Friendships_and_Feuds.htm">4. Friendships and Feuds</a></p>
<p class="contents" id="ch5">  <a href="#/5_Sport.htm">5. Sport</a></p>
<p class="contents" id="ch6">  <a href="#/6_Uses_for_a_Red_Cross_Parcel_Number_2__Cigarettes.htm">6. Uses for a Red Cross Parcel Number 2 – Cigarettes</a></p>
<p class="contents" id="ch7">  <a href="#/7_Stalag_Happy__Imaginary_Worlds_and_Other_Ways_of_Escape.htm">7. ‘Stalag Happy’ – Imaginary Worlds and Other Ways of Escape</a></p>
<p class="contents" id="ch8">  <a href="#/8_Uses_for_a_Red_Cross_Parcel_Number_3__Tins.htm">8. Uses for a Red Cross Parcel Number 3 – Tins</a></p>
<p class="contents" id="ch9">  <a href="#/9_POW_Artists.htm">9. POW Artists</a></p>
<p class="linespace"></p>
<p class="contents" id="ch9a"><a href="#/PART_II_THE_WAR_IN_THE_EAST.htm"><span class="part">PART II THE WAR IN THE EAST</span></a></p>
<p class="contents" id="ch10"><a href="#/10_Surrender.htm">10. Surrender</a></p>
<p class="contents" id="ch11"><a href="#/11_Changi.htm">11. Changi</a></p>
<p class="contents" id="ch12"><a href="#/12_Turned_Out_Rice_Again_Food_and_Cooking.htm">12. Turned Out Rice Again: Food and Cooking</a></p>
<p class="contents" id="ch13"><a href="#/13_Make_Do_and_Mend.htm">13. Make Do and Mend</a></p>
<p class="contents" id="ch14"><a href="#/14_Entertainment_Youll_Never_Get_Off_this_Island.htm">14. Entertainment: ‘You’ll Never Get Off this Island!’</a></p>
<p class="contents" id="ch15"><a href="#/15_Sport.htm">15. Sport</a></p>
<p class="contents" id="ch16"><a href="#/16_Recording_Captivity_Through_Art_and_Photography.htm">16. Recording Captivity Through Art and Photography</a><a id="pviii"></a></p>
<p class="contents" id="ch17"><a href="#/17_POW_Doctor.htm">17. POW Doctor</a></p>
<p class="contents" id="ch18"><a href="#/18_Taking_Flight_Escape_Through_Birdwatching.htm">18. Taking Flight: Escape Through Birdwatching</a></p>
<p class="contents" id="ch19"><a href="#/19_Survival_Teams.htm">19. Survival Teams</a></p>
<p class="contents" id="ch20"><a href="#/20_Escape_Through_Study.htm">20. Escape Through Study</a></p>
<p class="contents" id="ch21"><a href="#/21_University_of_Kuching.htm">21. University of Kuching</a></p>
<p class="contents" id="ch22"><a href="#/22_Languages_and_Communicating_with_the_Outside_World.htm">22. Languages and Communicating with the Outside World</a></p>
<p class="contents" id="ch23"><a href="#/23_Hidden_Wireless_Sets.htm">23. Hidden Wireless Sets</a></p>
<p class="contents" id="ch24"><a href="#/24_Religion.htm">24. Religion</a></p>
<p class="contents" id="ch25"><a href="#/25_The_Magic_of_Letters_from_Home.htm">25. The Magic of Letters from Home</a></p>
<p class="contents" id="ch26"><a href="#/26_The_Changi_Murals.htm">26. The Changi Murals</a></p>
<p class="linespace"></p>
<p class="contents" id="ch26a"><a href="#/PART_III_EUROPE.htm"><span class="part">PART III EUROPE</span></a></p>
<p class="contents" id="ch27"><a href="#/27_Reading_for_Profit.htm">27. Reading for Profit</a></p>
<p class="contents" id="ch28"><a href="#/28_Gardening_and_Birdwatching.htm">28. Gardening and Birdwatching</a></p>
<p class="contents" id="ch29"><a href="#/29_Study.htm">29. Study</a></p>
<p class="contents" id="ch30"><a href="#/30_Music_and_Theatre.htm">30. Music and Theatre</a></p>
<p class="linespace"></p>
<p class="contents" id="ch30a"><a href="#/PART_IV_THE_FAR_EAST.htm"><span class="part">PART IV THE FAR EAST</span></a></p>
<p class="contents" id="ch31"><a href="#/31_Upcountry_The_ThailandBurma_Railway.htm">31. ‘Upcountry’: The Thailand–Burma Railway</a></p>
<p class="contents" id="ch32"><a href="#/32_Art_and_Medicine_on_the_Railway.htm">32. Art and Medicine on the Railway</a></p>
<p class="contents" id="ch33"><a href="#/33_Archaeologist_on_the_Death_Railway.htm">33. Archaeologist on the ‘Death Railway’</a></p>
<p class="contents" id="ch34"><a href="#/34_Entertainment_and_Ingenuity_in_Thailand.htm">34. Entertainment and Ingenuity in Thailand</a></p>
<p class="contents" id="ch35"><a href="#/35_Home_Again_Changi_Gaol.htm">35. ‘Home’ Again: Changi Gaol</a></p>
<p class="contents" id="ch36"><a href="#/36_The_POW_Diaspora.htm">36. The POW Diaspora</a></p>
<p class="linespace"></p>
<p class="contents" id="ch36a"><a href="#/PART_V_FREEDOM.htm"><span class="part">PART V FREEDOM</span></a><a id="pix"></a></p>
<p class="contents" id="ch37"><a href="#/37_Somewhere_Near_the_End.htm">37. Somewhere Near the End</a></p>
<p class="contents" id="ch38"><a href="#/38_Victory_in_the_Far_East.htm">38. Victory in the Far East</a></p>
<p class="contents" id="ch39"><a href="#/39_Homecoming.htm">39. Homecoming</a></p>
<p class="linespace"></p>
<p class="contents" id="ch39a"><a href="#/PART_VI_EXPOWS.htm"><span class="part">PART VI EX-POWS</span></a></p>
<p class="contents" id="ch40"><a href="#/40_Aftermath.htm">40. Aftermath</a></p>
<p class="contents" id="ch0b">     <i><a href="#/Acknowledgements.htm">Acknowledgements</a></i></p>
<p class="contents">     <i><a href="#/Acknowledgements.htm#Hd1" id="H1">Permissions</a></i></p>
<p class="contents" id="ch41">     <i><a href="#/Notes.htm">Notes</a></i></p>
<p class="contents" id="ch42">     <i><a href="#/Bibliography.htm">Bibliography</a></i></p>
<p class="contents" id="ch43">     <i><a href="#/Index.htm">Index</a></i></p>
<p class="contents" id="ch44">     <i><a href="#/Copyright.htm">Copyright</a></i><a id="px"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?510550e9